import isObject from 'lodash/isObject';
import isNull from 'lodash/isNull';

import { BaseEventType } from './types';

export function validate(val, type, path = [], originalEvent) {
  return Object.keys(type).every((key) => {
    const targetValue = val[key];

    if (typeof type[key] === 'function') {
      const validationFn = type[key];
      if (!validationFn(targetValue)) {
        // eslint-disable-next-line no-console
        console.warn(
          `[EVENT] Failed validation for "${[...path, key].join(
            '.'
          )}" with value "${targetValue}" on event:`,
          originalEvent
        );
        return false;
      }
    }

    if (isObject(targetValue) && !isNull(targetValue)) {
      return validate(targetValue, type[key], [...path, key], originalEvent);
    }

    return true;
  });
}

export function validateTrack(event, BaseType = BaseEventType) {
  return validate(event, BaseType, [], event);
}
